import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  approveSubStepWithoutStages,
  getWorkflowCase,
  listWorkflowCases,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** Records the explicit approval required when a sub-step has no stages. */
export function useApproveSubStepWithoutStages(
  caseId: string,
): InvalidatingMutationResultFor<typeof approveSubStepWithoutStages> {
  return useInvalidatingMutation(approveSubStepWithoutStages, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
